/**
 * Query keys for search-related queries
 * Following hierarchical structure for efficient cache invalidation
 *
 * Example usage:
 * - Invalidate all searches: queryClient.invalidateQueries({ queryKey: searchKeys.all })
 * - Invalidate specific search: queryClient.invalidateQueries({ queryKey: searchKeys.query(searchTerm) })
 */
export const searchKeys = {
  all: ['search'] as const,
  queries: () => [...searchKeys.all, 'query'] as const,
  query: (term: string, limit?: number) =>
    [...searchKeys.queries(), { term, limit }] as const,
} as const;
